// Categories
export const CATEGORY_CATALOG = 'CATALOG';



// WEBPACK FOOTER //
// ./app/constants/ANALYTICS.ts